import React, { useContext, useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { DistributorFormContext } from "./FormContext";
import { FiUpload } from "react-icons/fi";
import ImageLoading from "../../../components/ImageLoading";

function StepOneForm({ setFormStep }) {
  const fileInputRef = useRef(null);

  const [openFilter, setOpenFilter] = useState(false);
  const {
    name,
    setName,
    email,
    setEmail,
    creditType,
    setCreditType,
    selectedImage,
    setSelectedImage,
    existLogo,
    setExistLogo,
    editMode,
    imageLoading,
  } = useContext(DistributorFormContext);
  const [nameError, setNameError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [hasNoStatus, setHasNoStatus] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
    }
  };
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const creditOPtions = [
    {
      name: "Lark",
    },
    {
      name: "Bajaj",
    },
  ];

  const handleFormOne = () => {
    const alphaNumRegex = /^[a-zA-Z0-9 _]*$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    const errors = {
      name:
        name === ""
          ? "Name is required"
          : !alphaNumRegex.test(name)
          ? "Name must be alphanumeric"
          : name.length > 31
          ? "Name must be less than 31 characters"
          : null,
      email: !email
        ? "Email is required"
        : !emailRegex.test(email)
        ? "Invalid email"
        : null,
      creditType: !creditType ? "Credit type is required" : null,
    };

    if (errors.name) {
      setNameError(errors.name);
      return;
    }
    if (editMode) {
      setFormStep(2);
      return;
    }
    if (errors.email) {
      setEmailError(errors.email);
      return;
    }
    if (errors.creditType) {
      setHasNoStatus(errors.creditType);
      return;
    }

    if (!errors.name && !errors.email && !errors.creditType) {
      setFormStep(2);
    }
  };
  return (
    <div>
      {imageLoading && (
        <div className=" w-full min-h-[355px] flex justify-center items-center ">
          <ImageLoading />
        </div>
      )}
      {!imageLoading && (
        <form className=" mt-6" onSubmit={(e) => e.preventDefault()}>
          <div className="flex  h-[81px]">
            <img
              src={
                selectedImage !== null
                  ? URL.createObjectURL(selectedImage)
                  : existLogo
              }
              alt=""
              className=" bg-[#d9d9d9] rounded-full w-[81px] object-contain"
            />
            <div className=" ml-[22px]">
              <p className="text-sm font-semibold">Logo image</p>
              <input
                type="file"
                accept=".png, .jpg, .jpeg"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              {!selectedImage && !existLogo && (
                <UploadButton
                  text="Upload image"
                  onClick={handleButtonClick}
                  width={"w-[230px]"}
                />
              )}
              <div className=" flex">
                {(selectedImage || existLogo) && (
                  <UploadButton
                    text="Replace image"
                    onClick={handleButtonClick}
                    width={"w-[147px]"}
                  />
                )}
                {(selectedImage || existLogo) && (
                  <UploadButton
                    text="Remove"
                    onClick={() => {
                      setSelectedImage(null);
                      setExistLogo(null);
                    }}
                    width={"w-[80px] ml-3"}
                  />
                )}
              </div>

              <p className=" mt-2 text-[10px] text-[#656565]">
                {" "}
                *png, *jpeg files up to 10MB
              </p>
            </div>
          </div>

          <div className=" flex items-center mt-[18px]">
            <label className=" w-[95px] text-sm font-medium">Name</label>
            <input
              value={name}
              onChange={(e) => {
                setNameError(null);
                setName(e.target.value);
              }}
              placeholder="Name"
              type="text"
              className="ml-2 w-[317px] h-[36px] rounded border border-[#e0e0e0] text-sm  pl-4 focus:outline-none text-[#00394d] font-medium"
            />
          </div>
          {nameError && (
            <div className="text-red-400  flex space-x-1 items-center mt-1 ">
              {/* <IoIosInformationCircle />{" "} */}
              <span className="text-xs">{nameError}</span>
            </div>
          )}
          <div className=" flex items-center mt-[18px]">
            <label className=" w-[95px] text-sm font-medium">Email</label>
            <input
              readOnly={editMode}
              value={email}
              onChange={(e) => {
                setEmailError(null);
                setEmail(e.target.value);
              }}
              placeholder="Email"
              type="email"
              className={` ml-2 w-[317px] h-[36px] rounded border border-[#e0e0e0] text-sm  pl-4 focus:outline-none text-[#00394d] font-medium ${
                editMode && " text-[#c6c6c6] "
              }`}
            />
          </div>
          {emailError && (
            <div className="text-red-400  flex space-x-1 items-center mt-1 ">
              {/* <IoIosInformationCircle />{" "} */}
              <span className="text-xs">{emailError}</span>
            </div>
          )}
          <div className=" flex items-center mt-[18px]">
            <label className=" w-[95px] text-sm font-medium">Credit type</label>
            <button
              onClick={() => {
                if (!editMode) {
                  setHasNoStatus(null);
                  setOpenFilter(!openFilter);
                }
              }}
              className={` ${
                editMode && "cursor-default text-[#c6c6c6]"
              } ml-2 relative py-2 px-[9px] pl-4 z-20 flex justify-between items-center bg-[#f8f8f8] ${
                creditType !== null ? "text-[#262626]" : "text-[#848484]"
              } border border-[#e0e0e0] rounded w-[317px] h-[36px] text-sm   focus:outline-none font-medium `}
            >
              {creditType === null ? "Select credit type" : creditType}
              <span>
                <IoIosArrowDown
                  className=" transition-all ease-in-out duration-100"
                  style={{
                    transform: openFilter ? "rotate(180deg)" : "rotate(0deg)",

                    color: editMode ? "#c6c6c6" : "#00394d",
                    width: 14,
                    height: 14,
                  }}
                />
              </span>
              {openFilter && (
                <div
                  onClick={(e) => e.stopPropagation()}
                  className="bg-white mt-1 absolute w-[317px]  rounded-[6px] p-1  shadow-lg  top-8 -right-[1px] h-[84px]"
                >
                  {creditOPtions.map((item, index) => {
                    return (
                      <button
                        onClick={() => {
                          setCreditType(item.name);
                          setOpenFilter(false);
                        }}
                        key={index}
                        className=" w-full h-[36px] text-left text-xs font-medium text-[#262626] hover:bg-[#a0ff77] flex items-center pl-4 rounded"
                      >
                        {item.name}
                      </button>
                    );
                  })}
                </div>
              )}
            </button>
          </div>
          {hasNoStatus && (
            <div className="text-red-400  flex space-x-1 items-center mt-1 ">
              {/* <IoIosInformationCircle />{" "} */}
              <span className="text-xs">{hasNoStatus}</span>
            </div>
          )}
          <div className=" flex justify-end items-center mt-8 ">
            <p className=" text-sm text-[#848484] mr-4">1 of 2 steps</p>
            <button
              onClick={handleFormOne}
              className=" bg-[#00394d] text-white h-[32px] w-[94px] rounded-lg text-sm font-semibold"
            >
              Next
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default StepOneForm;

const UploadButton = ({ text, width, margin, ...props }) => {
  return (
    <button
      {...props}
      className={` h-[32px]  ${width} mt-3 rounded text-sm font-semibold text-[#00394d] border border-[#e0e0e0] flex items-center justify-center`}
    >
      {text !== "Remove" && <FiUpload className="mr-2" size={15} />}
      {text}
    </button>
  );
};
